import { Conf, CrudService, Page } from 'elbuild-ui-lib-core';
// angular import
import { OnInit, Component, inject } from '@angular/core';
import { Router, NavigationStart, NavigationEnd, NavigationCancel, NavigationError, ActivatedRoute } from '@angular/router';

// project import
import { BuyNowLinkService } from './@theme/services/buy-now-link.service';
import { MessageService, Search, SharedDataService } from 'elbuild-ui-lib-core';
import { StoreEnv } from 'yf-commerce-model-ui-lib';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false
})
export class AppComponent implements OnInit {
  activeRoute = inject(ActivatedRoute);
  private productIdService = inject(BuyNowLinkService);

  // public props
  isSpinnerVisible = true;
  mainUrl: string;
  dev: boolean;
  loading: boolean;


  constructor(
    private messaservice: MessageService,
    private router: Router,
    private sharedDataService: SharedDataService,
    private confService: CrudService
  ) {
    this.sharedDataService.currentLoggedUser.subscribe(res => {
      if (res) {

        const confSearch: Search = new Search('conf');
        const confs = ['catalog.currency', 'fattura.elettronica', 'shop.mode', 'yfbase.env', 'date.format', 'date.timezone', 'backoffice.timezone', 'backoffice.dateformat', 'backoffice.timeformat'];
        confSearch.addInFilter('confkey', confs);
        this.confService.searchEntities(Conf, 'conf', confSearch, new Page(100))
          .subscribe((res: any[]) => {
            res.forEach((conf: Conf) => {
              this.sharedDataService.addCommonData(conf.confkey, conf.confval);
              if (conf.confkey === 'yfbase.env') {
                this.dev = conf.confval === StoreEnv.DEV;
                if (this.dev) {
                  document.body.classList.add('devenv');
                }

              }
            });
            this.loading = false;
          });
      }

    })
  }

  ngOnInit() {
    // Use ngOnInit instead of ngAfterViewInit
    this.router.events.subscribe(
      (event: any) => {
        if (event instanceof NavigationStart) {
          setTimeout(() => {
            this.isSpinnerVisible = true;
          });
        } else if (event instanceof NavigationEnd || event instanceof NavigationCancel || event instanceof NavigationError) {
          setTimeout(() => {
            this.isSpinnerVisible = false;
          });
        }
      },
      () => {
        setTimeout(() => {
          this.isSpinnerVisible = false;
        });
      }
    );
    const queryString = window.location.search;
    const params = new URLSearchParams(queryString);
    this.productIdService.setBuyNowLink(params);
  }
}
